<div class="button-wrapper" *ngIf="isArchived">
    <div *ngIf="!edit && !hideExtraFields && personaSubsectionIdentifier && personaIdentifier" class="group">
        <apc-extra-fields-buttons [pertinence]="pertinence" [section]="section" [subsection]="subsection"
            [personaSubsectionIdentifier]="personaSubsectionIdentifier" [personaIdentifier]="personaIdentifier"
            [formId]="formId">
        </apc-extra-fields-buttons>
    </div>

    <div class="seperated-group">
        <div *ngIf="navigation && navigation.length > 0 && !edit" [ngbTooltip]="navigation" tooltipClass="animation-tooltip"
            placement="top" container="body" triggers="hover">
            <button *checkPermission="permissionEdit" class="extra-button green" (click)="navigateToEvent.emit(true)" [disabled]="disableNavigation">
                <img src="assets/ico/visibility-report-button.svg" alt="Go to Report" />
            </button>
        </div>
        <div ngbTooltip="{{'buttons.edit' | translate}}" tooltipClass="animation-tooltip" placement="top"
            container="body" triggers="hover" *ngIf="!edit">
            <button *checkPermission="permissionEdit" class="extra-button yellow" (click)="editForm(false, $event)">
                <img class="edit" src="assets/ico/edit.svg" alt="edit" />
            </button>
        </div>
        <div *ngIf="!edit && deleteItem" ngbTooltip="{{'buttons.delete' | translate}}" tooltipClass="animation-tooltip"
            triggers="hover">
            <app-modal-info [title]="'Confirm action'" text="Are you sure to delete this item?" [color]="'red'"
                [isQuestion]="false" [iconSrc]="'assets/ico/trash-alt-regular.svg'" (confirmEvent)="delete()">
                <span action>
                    <button class="extra-button red">
                        <img src="assets/ico/trash-alt-regular.svg" alt="edit" />
                    </button>
                </span>
            </app-modal-info>
        </div>
        <div ngbTooltip="{{'buttons.save' | translate}}" tooltipClass="animation-tooltip" placement="top"
            container="body" triggers="hover" *ngIf="edit">
            <button class="extra-button green" (click)="saveForm()">
                <img class="save" src="assets/ico/save.svg" alt="save" />
            </button>
        </div>
        <div ngbTooltip="{{'buttons.undo' | translate}}" tooltipClass="animation-tooltip" placement="top"
            container="body" triggers="hover" *ngIf="edit">
            <button *ngIf="edit" class="extra-button red" (click)="cancelForm()">
                <img class="undo" src="assets/ico/undo-24px.svg" alt="back" />
            </button>
        </div>
    </div>
</div>